module.exports = __webpack_public_path__ + "img/nu.172512b8.png";